import React from 'react';
import { Helmet } from 'react-helmet-async';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import { Tooltip } from "bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import './css/resaAnnuelle.css';
const ResaAnnuelle = () => {
  let tooltipInstance = null;
  let location = useLocation();
  let navigate = useNavigate();

  function renderEventContent(eventInfo) {
    if (eventInfo.event.title === "reservation") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor }}>
          <div>Résa <i> {eventInfo.event.extendedProps.resa}</i></div>
          <div className=''>Couv <i> {eventInfo.event.extendedProps.couverte}</i></div>
        </div>
      )
    } else if (eventInfo.event.title === "fermeture") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor }}>
          <div><i> {eventInfo.event.title}</i></div>
        </div>
      )
    } else if (eventInfo.event.title === "fermeture avec resa") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor, border: '2px solid grey' }}>
          <div>Résa <i> {eventInfo.event.extendedProps.resa}</i></div>
          <div className=''>Couv <i> {eventInfo.event.extendedProps.couverte}</i></div>
        </div>
      )
    } else if (eventInfo.event.title === "fermeture partielle") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor, border: '2px solid grey' }}>
          <div><i> {eventInfo.event.title}</i></div>
        </div>
      )
    }

  }


  return (
    <div>
      <Helmet>
        <title>Réservation Annuelle</title>
        <meta name='description' content='Restaurant réservation annuelle .' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className="annuelle">
        <div className="bloc_annuelle">
          <div className='container'>
            <div className='annuelle_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-calendar-o'></i> <h1>Etats de réservations – vision annuelle</h1>
              </div>
              <div className='annuelle_renseignement'>
                <p>Affichage de la répartition des réservations de l’année, prenant en compte les créneaux de fermeture, vous permettant de visualiser rapidement votre activité et d’ajuster vos promotions, organisation et prises de réservation en direct.
                </p>
              </div>
            </div>
            <div className='annuelle_content'>
              <div className='d-flex justify-content-center'>
                <div className='calendar'>
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin]}
                    initialView="dayGridMonth"
                    height='500px'
                    allDayText='Heure'
                    firstDay='1'
                    slotLabelInterval='00:30:00'
                    slotMinTime='01:00:00'
                    slotMaxTime='24:00:00'
                    slotLabelFormat={[
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        meridiem: false,
                      },
                    ]}
                    buttonText={{
                      today: "Cette mois",
                      month: 'Mois'
                    }}
                    eventContent={renderEventContent}
                    headerToolbar={{
                      left: 'prevYear,nextYear',
                      center: 'title',
                      right: 'prev,today,next'
                    }}

                    events={[
                      {
                        title: 'reservation', date: '2022-09-23T10:30:00', backgroundColor: '#4ba7cc', couverte: 10, resa: 20, textColor: '#fff', display: 'block', borderColor: 'skyblue'
                      },
                      {
                        title: 'reservation', date: '2022-09-06T07:00:00', backgroundColor: '#4ba7cc', display: 'block', textColor: '#fff', couverte: 23, resa: 12, borderColor: 'skyblue'
                      },
                      { title: 'fermeture avec resa', date: '2022-09-22T08:00:00', backgroundColor: '#4ba7cc', display: 'block', textColor: '#fff', couverte: 40, resa: 62, borderColor: 'grey' },
                      { title: 'fermeture partielle', date: '2022-09-25T07:00:00', backgroundColor: '#fff', display: 'block', textColor: 'black', borderColor: 'grey' },
                      { title: 'fermeture', start: '2022-09-08T10:30:00', end: '2022-09-05T10:30:00', backgroundColor: '#cacaca', display: 'background', textColor: '#fff', borderColor: 'white' },
                    ]}
                    eventClick={(info) => {
                      if (info.event.title === "reservation" || info.event.title === "fermeture avec resa") {
                        if (tooltipInstance) {
                          tooltipInstance.dispose();
                          tooltipInstance = null;
                        }

                        navigate('/restaurant/resaMensuelle', { state: { title: info.event.title, date: info.event.date, donner: info.event.extendedProps } });
                      }

                    }}
                    eventMouseEnter={(info) => {
                      if (info.event.title === "reservation" || info.event.title === "fermeture avec resa") {
                        var tooltipContent = '<div className="calendarTooltip" style="padding-left:10px; text-align: center;width:185px;height:35px;background:#126da2; border-radius: 8px; color: white;position:absolute;z-index:10001;"><div style=background:white;><div>' + info.event.start.toLocaleDateString() + '</div> Nbre de couvert: ' + info.event.extendedProps.couverte + '</div> <div> Nbre de Réservation: ' + info.event.extendedProps.resa + '</div></div>';
                        tooltipInstance = new Tooltip(info.el, {
                          title: tooltipContent,
                          html: true,
                          placement: "bottom",
                          trigger: "hover",
                          container: "body"
                        });

                        tooltipInstance.show();
                      }
                    }}
                    eventMouseLeave={() => {
                      if (tooltipInstance) {
                        tooltipInstance.dispose();
                        tooltipInstance = null;
                      }
                    }}
                    locale='fr'
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResaAnnuelle